// import { createBrowserRouter } from "react-router-dom";
// import HomeComponent from "../components/HomeComponent";
// import DocumentView from "../pages/DocumentView";
// import Login from "../pages/Login";
// import UploadDocuments from "../pages/UploadDocuments";

// const router = createBrowserRouter([
//   {
//     path: "/",
//     element: <HomeComponent />,
//   },
//   {
//     path: "/home",
//     element: <HomeComponent />,
//   },
//   {
//     path: "/documents",
//     element: <UploadDocuments />,
//   },
//   {
//     path: "/documents/:id",
//     element: <DocumentView />,
//   },
//   {
//     path: "/login",
//     element: <Login />,
//   },
// ]);

// export default router;

import { createBrowserRouter, Navigate } from "react-router-dom";
import WithHeaderLayout from "../components/WithHeaderLayout";
import WithoutHeaderLayout from "../components/WithoutHeaderLayout";

import HomeComponent from "../components/HomeComponent";
import DocumentView from "../pages/DocumentView";
import Login from "../pages/Login";
import UploadDocuments from "../pages/UploadDocuments";
import List from "../pages/List";
import AI_PDF_CONST from "../util/PdfAiConst";
import PrivateRoute from "../util/PrivateRoute";
import Holios from "../pages/Holios";
import HoliosUploadData from "../pages/HoliosUploadData";
import AIAutomation from "../pages/AIAutomation";
import AiLanding from "../pages/AiLanding";
import AIAutomationOptionA from "../pages/AIAutomationOptionA";
import AIAutomationOptionB from "../pages/AIAutomationOptionB";
import AIAutomation2 from "../pages/AIAutomation2";
import Communication from "../pages/Communication";
import AiComm from "../pages/AiComm";
import PdfToExl from "../pages/PdfToExl";
import MyDocs from "../pages/MyDocs";
import VoiceCall from "../pages/VoiceCall";
import AdminOrgsPage from "../pages/AdminOrgsPage";
import AdminOrgUsersPage from "../pages/AdminOrgUsersPage";
import Home2 from "../pages/Home2/App";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import TermsOfService from "../pages/TermsOfService";
import DataDeletion from "../pages/DataDeletion";
const router = createBrowserRouter([
  {
    element: <WithHeaderLayout />,
    children: [
      {
        path: AI_PDF_CONST.ROUTE.ROOT,
        element: <Navigate to={AI_PDF_CONST.ROUTE.HOME} />,
      },
      { path: AI_PDF_CONST.ROUTE.HOME, element: <HomeComponent /> },
      {
        path: AI_PDF_CONST.ROUTE.DOCUMENTS,
        element: <PrivateRoute element={<UploadDocuments />} />,
      },
      {
        path: "/documents/:id",
        element: <PrivateRoute element={<DocumentView />} />,
      },
      {
        path: AI_PDF_CONST.ROUTE.DASHBOARD,
        element: <PrivateRoute element={<List />} />,
      },
      {
        path: AI_PDF_CONST.ROUTE.HOLIOS,
        element: <Holios />,
      },
      {
        path: AI_PDF_CONST.ROUTE.HOLIOS_UPLOAD_DATA,
        element: <HoliosUploadData />,
      },
      {
        path: AI_PDF_CONST.ROUTE.AI_AUTOMATION,
        element: <AIAutomation />,
      },
      {
        path: "/ai",
        element: <AiLanding />,
      },
      {
        path: "/ai-a",
        element: <AIAutomationOptionA />,
      },
      {
        path: "/ai-b",
        element: <AIAutomationOptionB />,
      },
      {
        path: "/ai-automation2",
        element: <AIAutomation2 />,
      },
      {
        path: "/communication",
        element: <Communication />,
      },
      {
        path: "/ai-comm",
        element: <AiComm />,
      },
      {
        path: "/pdf-to-exl",
        element: <PdfToExl />,
      },
      {
        path: "/my-docs",
        element: <PrivateRoute element={<MyDocs />} />,
      },
      {
        path: "/voice-call",
        element: <PrivateRoute element={<VoiceCall />} />,
      },
      {
        path: AI_PDF_CONST.ROUTE.ADMIN_ORGS,
        element: <PrivateRoute element={<AdminOrgsPage />} />,
      },
      {
        path: AI_PDF_CONST.ROUTE.ADMIN_ORG_USERS,
        element: <PrivateRoute element={<AdminOrgUsersPage />} />,
      },
      { path: "/privacy", element: <PrivacyPolicy /> },
      { path: "/terms", element: <TermsOfService /> },
      { path: "/data-deletion", element: <DataDeletion /> },
    ],
  },
  {
    element: <WithoutHeaderLayout />,
    children: [
      { path: "/home2", element: <Home2 /> },
      { path: "/login", element: <Login /> },
      // Add more routes here if needed
    ],
  },
]);

export default router;
